import React from 'react';
import { Eye, EyeSlash } from 'phosphor-react';
import TrocaIcone from '../ui/TrocaIcone';
import StyledInput from './StyledInput';

type StyledInputProps = React.ComponentPropsWithoutRef<typeof StyledInput>;

/**
 * Campo de senha com o olho de mostrar/ocultar.
 *
 * Existia copiado em Login e Register e faltava em todo o resto (alterar senha,
 * redefinir senha, confirmar exclusão da conta) — no terceiro lugar virou componente.
 * O `type` é dele; o resto das props é o do StyledInput, inclusive o `ref` do
 * register do react-hook-form.
 */
const PasswordInput = React.forwardRef<HTMLInputElement, Omit<StyledInputProps, 'type' | 'rightIcon'>>(
  function PasswordInput(props, ref) {
    const [mostrando, setMostrando] = React.useState(false);

    return (
      <StyledInput
        {...props}
        ref={ref}
        type={mostrando ? 'text' : 'password'}
        rightIcon={
          <button
            type="button"
            onClick={() => setMostrando((v) => !v)}
            className="flex items-center text-nude-400 hover:text-blush-500 transition-colors"
            aria-label={mostrando ? 'Ocultar senha' : 'Mostrar senha'}
          >
            <TrocaIcone
              ativo={mostrando}
              quandoAtivo={<EyeSlash className="w-4 h-4" />}
              quandoInativo={<Eye className="w-4 h-4" />}
            />
          </button>
        }
      />
    );
  }
);

export default PasswordInput;
